import React from 'react';
import { Page } from '../Page';
import { Zap, Heart, Brain } from 'lucide-react';
export function SupplementCoQ10() {
  return <Page pageNumber={16} variant="light" data-id="element-3372" data-mp="pqvssti0kv08">
      <div className="flex h-full gap-10" data-id="element-3373" data-mp="13pc0amnpapjf">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3374" data-mp="13n8zr8ox9e0g">
          <img src="https://cdn.magicpatterns.com/uploads/t2rnxGtAEqZJZyXdw5PAnf/pasted-image.png" alt="Thorne CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-3375" data-mp="yopdt8abw283" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3376" data-mp="1mgcxb559gb0c">
          <div className="mb-6 pt-4" data-id="element-3377" data-mp="1mf1up8njx9at">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3378" data-mp="1iehxk52za5oo">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3379" data-mp="1weiyfkj8td45">
              CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3380" data-mp="1rctlfzcgmpdf">
              Cellular energy + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3381" data-mp="s71mmp6ypf4" />
          </div>

          <div className="mb-8" data-id="element-3382" data-mp="5s35mlxw2guo">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3383" data-mp="5rtolnutnk14">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3384" data-mp="9rke7o8m3u42">
              Cellular energy production becomes critical when caloric intake
              drops. CoQ10 fuels the mitochondria that power your heart, brain,
              and muscles. It also provides antioxidant protection during the
              metabolic stress of rapid weight loss and supports cardiovascular
              health, important since many GLP-1 patients have cardiometabolic
              risk factors.
            </p>
          </div>

          <div className="mb-8" data-id="element-3385" data-mp="12i2qnfv877u5">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3386" data-mp="12jdsvb90w7j5">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3387" data-mp="2yma34msz8wc6">
              <li className="flex gap-2" data-id="element-3388" data-mp="2ukonwusz05yt">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3389" data-mp="2uhsn8ypqn36o" />
                <span data-id="element-3390" data-mp="38c235wjuiho1">
                  Supports heart health and cardiovascular function during
                  weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3391" data-mp="3i8yc23dnp5t4">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3392" data-mp="3i7mzbe28gnpv" />
                <span data-id="element-3393" data-mp="3d9brf8vi0naa">
                  Maintains cellular energy production during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3394" data-mp="3r81v57ctpl7m">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3395" data-mp="3matdd7vl7j6w" />
                <span data-id="element-3396" data-mp="1wvvazj1ybu36">
                  Provides antioxidant support for brain function and cognitive
                  health
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3397" data-mp="1rz4w2z1vv4jc">
                <span className="text-tealslate shrink-0" data-id="element-3398" data-mp="7ehnk88aw1uk">•</span>
                <span data-id="element-3399" data-mp="7hc61u7r7clc">
                  Proprietary well-absorbed form with lycopene + turmeric, NSF
                  Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3400" data-mp="3uq94wini35u6">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3401" data-mp="2nhr1433flsl">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3402" data-mp="3ku5tem6rduuk">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3403" data-mp="3pu0nszpqt2kd">
                <strong data-id="element-3404" data-mp="3bt7qk7823tdk">1-2 gelcaps daily</strong> with a meal containing fat
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3405" data-mp="3fut8i6zg6xum">
                100mg CoQ10 per gelcap • 60 gelcaps per bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3406" data-mp="1a35z69pc67lt">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3407" data-mp="1e36dzvgckkte" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3408" data-mp="kf0iv9zdin6z">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}